import { render } from "./BookImport.vue?vue&type=template&id=66f8fe5c&scoped=true"
import script from "./BookImport.vue?vue&type=script&lang=js"
export * from "./BookImport.vue?vue&type=script&lang=js"

import "./BookImport.vue?vue&type=style&index=0&id=66f8fe5c&lang=scss&scoped=true"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f8fe5c"]])

export default __exports__